import classNames from "classnames";

import { CCard, CCardBody, CCol, CRow } from "@coreui/react";

import { CActionGroup } from "src/common/components/others";
import { useMobileDevice } from "src/utils/hooks/viewport";

export const Toolbar = ({ onSubmit }) => {
  const isMobile = useMobileDevice();
  return (
    <CCard className={classNames("toolbar", !isMobile && "sticky")}>
      <CCardBody>
        <CRow>
          <CCol xs="12" className="action">
            <div>
              <CActionGroup onClick={onSubmit} canAdd={false} canSave />
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
};
